$(function() {
    var pageUrl = encodeURIComponent(document.URL);
    $('a.facebook-share').attr('href', 'https://www.facebook.com/sharer.php?u=' + pageUrl);
});

$('.share-group').click(function() {
    var pageUrl = window.location.href;
    let textarea = document.createElement('textarea');
    textarea.id = 't';
    textarea.style.height = 0;
    document.body.appendChild(textarea);
    textarea.value = pageUrl;
    let selector = document.querySelector('#t');
    selector.select();
    document.execCommand('copy');
    document.body.removeChild(textarea);
    $(this)
        .siblings('.copied-success')
        .removeClass('hidden');
    setTimeout(function() {
        $('.copied-success').addClass('hidden');
    }, 2000);
});

/// Successful registration message

function getParameterByName(name, url) {
    if (!url) url = window.location.href;
    name = name.replace(/[\[\]]/g, '\\$&');
    var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
        results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, ' '));
}
var dynamicContent = getParameterByName('registered');
if (dynamicContent == '1') {
    $('#modal-registered').modal();
}

/// Sort registrants

function sortDown(a, b) {
    return a.className > b.className;
}

function sortUp(a, b) {
    return a.className < b.className;
}

$('#sort-participants-down').click(function() {
    $(this).addClass('active-button');
    $('#sort-participants-up').removeClass('active-button');
    var elem = $('#group-participants')
        .find('li')
        .sort(sortDown);
    $('#group-participants').append(elem);
});

$('#sort-participants-up').click(function() {
    $(this).addClass('active-button');
    $('#sort-participants-down').removeClass('active-button');
    var elem = $('#group-participants')
        .find('li')
        .sort(sortUp);
    $('#group-participants').append(elem);
});

$(document).ready(function() {
    var elem = $('#group-participants')
        .find('li')
        .sort(sortDown);
    $('#group-participants').append(elem);
});

/// Back to Top button

$('.back-to-top').click(function() {
    $('html, body').animate({ scrollTop: 0 });
});

/// Tabs

$('.groups-tabs').tabslet({
    animation: true
});

/// Recaptcha

if( $('#recaptchaResponse').length) {
grecaptcha.ready(function () {
    grecaptcha.execute('6Lerg-kUAAAAAOKHCBzpYMKugpr8WKG6fNPdhy6K', { action: 'register' }).then(function (token) {
        var recaptchaResponse = document.getElementById('recaptchaResponse');
        recaptchaResponse.value = token;
    });
});
}


/// Reveal leader email

if($('#leader-email').length) {
    var leaderEmail = $("#leader-email").data("email");
    var leaderEmail = launchframe.ajax_url+"?action=decrypt_leaders_email&email=" + (leaderEmail);
    $("#leader-email").click(function(event){
       $.getJSON((leaderEmail), function(email) {
          $('#display-email').html('<p><a class="text-lg font-medium" href="mailto:' + email.email + '">' + email.email + '</a></p>');
          $('#display-email').fadeIn();
       });
       $(this).fadeOut();
    });
}

if($('#leader-phone').length) {
    var leaderPhone = $("#leader-phone").data("phone");
    var leaderPhone = launchframe.ajax_url+"?action=decrypt_leaders_phone&phone=" + (leaderPhone);
    $("#leader-phone").click(function(event){
       $.getJSON((leaderPhone), function(f) {
          $('#display-phone').html('<p class="text-lg font-medium">' + f.phone + '</p>');
          $('#display-phone').fadeIn();
       });
       $(this).fadeOut();
    });
}



